
export const IS_PRE_RELEASE = false;
export const VERSION = "0.18.7";
export const VERSION_BUILD = "427";
